import React, { useState, useEffect } from 'react';
import { __ } from '@wordpress/i18n';
import { Title, Button } from '@bsf/force-ui';
import apiFetch from '@wordpress/api-fetch';
import { Toaster, toast } from 'react-hot-toast';

const MapSettings = () => {
    const [mapKey, setMapKey] = useState('');

    useEffect(() => {
        apiFetch({
            path: '/ultimate-vc/v1/map-key',
            method: 'GET',
            headers: { 'X-WP-Nonce': uavcSettingsData.nonce },
            credentials: 'same-origin',
        })
            .then((response) => {
                if (response && response.map_key) {
                    setMapKey(response.map_key);
                }
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.error('Error fetching map key:', error);
            });
    }, []);

    const handleSave = () => {
        if (!mapKey.trim()) {
            toast.error(__('API key is missing.', 'ultimate_vc'));
            return;
        }

        let validation;
        apiFetch({
            path: '/ultimate-vc/v1/map-key/validate',
            method: 'POST',
            headers: { 'X-WP-Nonce': uavcSettingsData.nonce },
            credentials: 'same-origin',
            data: { map_key: mapKey },
        })
        .then(response => {
            // Handle successful response
            validation = response;
            toast.success(validation.message || __('API key validated successfully.', 'ultimate_vc'));
            // Add any additional success handling here
        })
        .catch(error => {
            console.error('Error validating API key:', error);
            toast.error(error?.message || __('Failed to validate API key.', 'ultimate_vc'));
            return;
        });

    };

    return (
        <>
             <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerStyle={{
          top: 20,
          right: 20,
          marginTop: '40px',
        }}
        toastOptions={{
          duration: 1000,
          style: {
            color: '#0017E1',
          },
          success: {
            duration: 2000,
            style: {
              color: '',
            },
            iconTheme: {
              primary: '#0017E1',
              secondary: '#fff',
            },
          },
        }}
      />
            <Title size="sm" tag="h2" title={__('Google Maps', 'ultimate_vc')} />
            <div className="box-border bg-background-primary p-6 rounded-lg" style={{ marginTop: '24px', }}>
                <div className="flex items-center justify-start gap-2">
                    <div>
                        <label className="block text-base font-semibold mb-2">
                            {__('API Key', 'ultimate_vc')}
                        </label>
                        <input
                            type="text"
                            value={mapKey}
                            onChange={(e) => setMapKey(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleSave();
                                }
                            }}
                            className="border rounded-md border-gray-300"
                            style={{
                                borderColor: '#e0e0e0', // Default border color
                                outline: 'none',       // Removes the default outline
                                boxShadow: 'none',     // Removes the default box shadow
                                marginTop: '8px',
                                width: '32.75rem',
                                height: '46px',
                            }}
                        />
                    </div>
                    <Button
                        variant="primary"
                        className="bg-[#0017E1] uavc-remove-ring"
                        style={{
                            backgroundColor: "#0017E1",
                            transition: "background-color 0.3s ease",
                            height: '46px',
                            marginTop: '32px',
                        }}
                        onClick={handleSave}
                    >
                        {__('Save Changes', 'ultimate_vc')}
                    </Button>
                </div>
                <p className="text-sm text-[#9CA3AF] mt-2" style={{ color: '#9CA3AF' }}>
                    {__('Get your API Key', 'ultimate_vc')}{' '}
                    <a href="https://developers.google.com/maps/documentation/javascript/get-api-key" target="_blank" rel="noopener noreferrer" style={{ color: '#0017E1' }}>
                        {__('here', 'ultimate_vc')}
                    </a>{' '}
                    {__('or', 'ultimate_vc')}{' '}
                    <a href="https://ultimate.brainstormforce.com/docs/guide-to-setting-up-google-api-key-for-maps-integration/" target="_blank" rel="noopener noreferrer" style={{ color: '#0017E1' }}>
                        {__('read this article', 'ultimate_vc')}
                    </a>{' '}
                    {__('for more information.', 'ultimate_vc')}
                </p>
            </div>
        </>
    );
};

export default MapSettings;